import { c as _c } from "react/compiler-runtime";
import { CLIENT_ID } from "@api/client-id";
// eslint-disable-next-line no-restricted-imports -- One of the central places to import CoreApiTokenManager.
import { CoreApiTokenManager } from "@faro-lotv/service-wires";
import { runtimeConfig } from "@src/runtime-config";
import { useMemo } from "react";

/** Map from stringified combination of company ID and project ID to cached token provider. */
const tokenProviderMap = {};

/**
 * Returns a token provider for the given project ID and/or company ID. The instance is cached, so that the /auth/token endpoint
 * will be called only once per company and/or company and project as long as the token is valid.
 * @param companyId Optional company ID
 * @param projectId Optional project ID
 * @returns Function that returns a Promise for a token.
 */
export function getCachedCompanyTokenProvider(companyId, projectId, activity) {
  /** Using a key combination with companyId, projectId and activity data */
  const key = `${JSON.stringify({
    companyId,
    projectId,
    activity
  })}`;
  if (!tokenProviderMap[key]) {
    const coreApiUrl = new URL(runtimeConfig.urls.apiBaseUrl);
    const scopes = ["user:project", "company:insights"];
    if (activity) {
      scopes.push("activity");
    }
    const tokenManager = new CoreApiTokenManager({
      coreApiUrl,
      scopes,
      companyId,
      projectId,
      clientId: CLIENT_ID,
      // Scopes to use in order to provide a user access to a project and company
      ...(activity && {
        activity: {
          companyId: activity.companyId,
          projectId: activity.projectId,
          userId: activity.userId
        }
      })
    });
    tokenProviderMap[key] = tokenManager.getToken.bind(tokenManager);
  }
  return tokenProviderMap[key];
}

/**
 * Returns a token provider for the given optionally company ID and/or project ID.
 * The instance is cached, so that the /auth/token endpoint
 * will be called only once per company and/or company and project as long as the token is valid.
 * @param companyId Optional company ID
 * @param projectId Optional project ID
 * @returns Function that returns a Promise for a token.
 */
export function useCachedCompanyTokenProvider(t0) {
  const $ = _c(4);
  const {
    companyId,
    projectId,
    activity
  } = t0;
  let t1;
  if ($[0] !== activity || $[1] !== companyId || $[2] !== projectId) {
    t1 = getCachedCompanyTokenProvider(companyId, projectId, activity);
    $[0] = activity;
    $[1] = companyId;
    $[2] = projectId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}